import { User } from "../../types/User";
import axiosInstance from "../../utils/AxiosInstance";
import { TokenStorage } from "../../utils/TokenStorage";

export interface LoginData {
  email: string;
  password: string;
}

interface LoginResponse {
  userId: string;
  fullName: string;
  email?: string;
  companyId: string | null;
  securityLevel: number;
  accessToken: string;
}

export function login(data: LoginData): Promise<User> {
  return axiosInstance
    .post<LoginResponse>("/login", {
      email: data.email,
      password: data.password,
    })
    .then((response) => {
      if (response.data.accessToken) {
        TokenStorage.setToken(response.data.accessToken);
      }
      const { accessToken: _accessToken, ...userData } = response.data;
      return userData as User;
    });
}
